export default {
    ENTIRE_COUNTRY: 'ENTIRE_COUNTRY',
    REGIONS: 'REGIONS',
    CITIES: 'CITIES',
    DMAS: 'DMAS',
    ZIPCODES: 'ZIPCODES',
};
